import ErrorBoundary from "@/components/ErrorBoundary/errorBoundary.component";
import Navbar from "@/infrastructure/Navbar/navbar.component";
import Sidebar from "@/infrastructure/Sidebar/sidebar.component";
import { Toaster } from "@/shadcn/components/ui/sonner";
import React, { useState } from "react";

type BasePageProps = {
  children: React.ReactNode;
  currPage: string;
};

const BasePage: React.FC<BasePageProps> = ({ children, currPage }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(
    // based on screen size, open the sidebar by default on desktop and close it on mobile
    window.innerWidth < 768 ? false : true
  );

  return (
    <div className="flex h-full flex-col">
      <ErrorBoundary>
        <Navbar
          currPage={currPage}
          isSidebarOpen={isSidebarOpen}
          setIsSidebarOpen={setIsSidebarOpen}
        />
      </ErrorBoundary>
      <div className="relative flex h-full flex-1 overflow-hidden">
        <ErrorBoundary>
          <Sidebar
            currPage={currPage}
            isSidebarOpen={isSidebarOpen}
            setIsSidebarOpen={setIsSidebarOpen}
          />
        </ErrorBoundary>
        <div className="h-full w-full grow">
          <ErrorBoundary>{children}</ErrorBoundary>
        </div>
      </div>
    </div>
  );
};

export default BasePage;
